import { createSlice } from "@reduxjs/toolkit";

const jdBuilderAccessSlice = createSlice({
  name: "jdBuilderAccess",
  initialState: {
    jdBuilderAccessible: undefined,
    jdBuilderRole: null,
  },
  reducers: {
    setJdBuilderAccess: (_, action) => ({
      jdBuilderAccessible: !!action.payload.jd_builder_access,
      jdBuilderRole: action.payload.jd_builder_role || null,
    }),
    resetJdBuilderAccess: () => ({
      jdBuilderAccessible: undefined,
      jdBuilderRole: null,
    }),
  },
});

export const { setJdBuilderAccess, resetJdBuilderAccess } = jdBuilderAccessSlice.actions;
export default jdBuilderAccessSlice.reducer;